import {
  HashtagMentionTypeEnum,
  IGetFileCabinetItemHashtagSuggestion,
  IGetHashtagSuggestion,
  IGetPhaseItemHashtagSuggestion,
  IGetSelectionHashtagSuggestion,
  IGetSelectionOptionHashtagSuggestion,
  IHashtagMention,
} from 'redux-store/api/activity-feed/hashtags.types';

export const mapHashtagSuggestion = (item: IGetHashtagSuggestion): IHashtagMention => {
  const handleFileCabinetItem = (item: IGetFileCabinetItemHashtagSuggestion) => ({
    name: item.name,
    id: item.id,
    type: item.type,
    mimeType: item.mimeType,
  });

  const handlePhaseItem = (item: IGetPhaseItemHashtagSuggestion) => ({
    name: item.title,
    id: item.id,
    type: item.type,
  });

  const handleSelection = (item: IGetSelectionHashtagSuggestion) => ({
    name: item.title,
    id: item.id,
    type: item.type,
  });

  const handleSelectionOption = (item: IGetSelectionOptionHashtagSuggestion) => ({
    name: item.title,
    id: item.id,
    type: item.type,
    selectionItemId: item.selectionItemId,
  });

  const handlers: Record<HashtagMentionTypeEnum, (item: IGetHashtagSuggestion) => IHashtagMention> =
    {
      [HashtagMentionTypeEnum.fileCabinetItem]: handleFileCabinetItem,
      [HashtagMentionTypeEnum.phaseItem]: handlePhaseItem,
      [HashtagMentionTypeEnum.selection]: handleSelection,
      [HashtagMentionTypeEnum.selectionOption]: handleSelectionOption,
    };

  const handler = handlers[item.type];

  return handler(item);
};
